
































































































































































import { Prop, Component, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { UserMeta, Team, UserPlan, AvailablePlan } from "../../types";
import axios from "axios";
import consts from "../../consts";
import { getters } from "../../store/getters";
import { source, refreshAxiosCancelToken } from "@/store/actions";
import { getDomain } from "@/auth";
import amplitude from "amplitude-js";
import SubscribePlanSelection from "../subscribeplanselection.vue";

@Component({
  components: {
    SubscribePlanSelection,
  },
})
export default class LearnerAccount extends Vue {
  @Action private fetchUserMeta!: () => any;
  @Action private fetchAvailablePlans!: () => any;
  @Getter private userMeta!: UserMeta;
  @Getter private teams!: Team[];
  @Getter private userPlan!: UserPlan;
  @Getter private userPlanLoading!: boolean;
  @Getter private proPlan!: AvailablePlan;
  @Getter private JWT!: string;
  @Getter private UID?: string;

  @Action private resetState: any;

  private $amplitude: any;

  @Prop() private showPurchaseOptions!: boolean;
  private selectedOption = "";

  private showDeleteAccountModal: boolean = false;
  private userdeleteloading: boolean = false;

  private created() {
    debugger;
    this.fetchUserMeta();
    this.fetchAvailablePlans();

    // Setup amplitude
    // source.cancel();
    // let domain = getDomain(window.location.href) as string | undefined;
    // this.$cookies.remove("ORAI_AUTH", "/", domain);
    // this.$cookies.remove(consts.currentLearnerTeam, "/", domain);
    // localStorage.clear();
    // this.resetState();
    // refreshAxiosCancelToken();
    // amplitude.getInstance().init(consts.amplitudeKey, "", {
    //   saveEvents: true,
    //   includeUtm: true,
    //   includeReferrer: true,
    // });
    // this.$amplitude = amplitude.getInstance();
  }

  private async deleteAccount() {
    this.userdeleteloading = true;
    const response = await axios({
      method: "DELETE",
      url: consts.serverURL + `user/${this.UID}`,
      headers: { Authentication: this.JWT },
    });
    this.userdeleteloading = false;
    if (response.status == 200)
      this.$router.push({
        name: "login",
      });
    return;
  }

  private async goToBillingPortal() {
    const response = await axios({
      // url: consts.serverURL + `user/${this.UID}`,
      url: consts.serverURL + `subscription/stripe/billingportal`,
      headers: { Authentication: this.JWT },
    });
    
     window.open(response.data['URL'] , '_blank');
    // this.$router.push("/subscription");
  }
}
